import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import store from '../store'

Vue.use(Vuex, axios)

const createHeader = function () {
  const credential = store.getters['config/getCredential']
  var userLang = navigator.language || navigator.userLanguage
  var headerObj = {};
  if (credential) {
    if (!credential.locale) {
      credential.locale = userLang.replace('-', '_')
    }
    if (credential && credential.apiEncryptedUser) {
      headerObj = {
        'X-ApiEncryptedUser': credential.apiEncryptedUser
      }
    } else if (credential && credential.apiKey) {
      headerObj = {
        'X-ApiKey': credential.apiKey
      }
    }
  }
  return headerObj;
}

export default {

  getStoneFilters() {
    const credential = store.getters['config/getCredential']
    const buildYourJewelModeSetting = store.getters['buildYourJewel/getSelectedSetting'];
    const buildYourJewelStonesNumber = store.getters['buildYourJewel/getStonesNumber'];

    const params = new URLSearchParams();
    if (buildYourJewelModeSetting) {
      params.append('settingSku', buildYourJewelModeSetting.sku);
    }
    if (buildYourJewelStonesNumber)
      params.append('jewelStonesNumber', buildYourJewelStonesNumber);
    params.append('locale', credential?.locale);
    return axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/build-your-jewel/stone/filters`,
        {
          headers: createHeader(),
          params
        }
      )
  },

}
